import { useTranslations } from "next-intl";

export const useDeliveryDelayCard = () => {
  const t = useTranslations("Libs.UI.Components.DeliveryDelayCard");

  return {
    title: t("title"),
    expectedLabel: t("expectedLabel"),
    delayLabel: t("delayLabel"),
  };
};
